import { Component } from '@angular/core';

/**
 * コマ商品
 *
 * @export
 * @class GoodsComponent
 */
@Component({
  selector: 'app-goods',
  template: '',
})

export class GoodsComponent {
  public pcodeList: Array<string> = new Array<string>();
  public pcodeList2: Array<string> = new Array<string>();
  public layoutInfo: any = null;
  public imageInfo: any = null;
  public promotionName = String('');
  /**
   * レイアウト、イメージ情報設定
   *
   * @param {*} layoutInfo レイアウト情報
   * @param {*} imageInfo イメージ情報
   * @memberof GoodsComponent
   */
  public setData(layoutInfo: any, imageInfo: any, promotionName: string): void {
    this.layoutInfo = layoutInfo;
    this.imageInfo = imageInfo;
    this.promotionName = promotionName;
    if (layoutInfo != null) {
      for (const goods of layoutInfo) {
        this.pcodeList.push(goods.PCode);
      }
    }
  }

  /**
   * 商品リスト情報を取得する※実績履歴用
   *
   * @returns {Array<any>}
   * @memberof GoodsComponent
   */
  public getGoodsList(): Array<any> {
    return this.createGoodsList();
  }

  /**
   * 商品リスト情報を生成する※実績履歴用
   *
   * @returns {Array<any>}
   * @memberof GoodsComponent
   */
  public createGoodsList(): Array<any> {
    const goodsList: Array<any> = new Array<any>();
    // レイアウト(商品)情報処理
    if (this.layoutInfo != null) {
      let selectedGoods: any = new Object();
      this.layoutInfo.forEach(goods => {
        selectedGoods = new Object();
        selectedGoods.PCode = goods.PCode;
        selectedGoods.GuideGoodsName = goods.GuideGoodsName;
        selectedGoods.GuideStandardName = goods.GuideStandardName;
        goodsList.push(selectedGoods);
      });
    }
    return goodsList;
  }

}
